import { html, nothing, type TemplateResult } from 'lit';
import { SHELL_SYNC_NAV_PATH } from '@src/modules/shared/app-context/domain/shellNavRoutes.ts';
import { shellNavPathname } from '@src/modules/shared/app-context/domain/shellNavRoutes.ts';

export { SHELL_SYNC_NAV_PATH };

/** Display label for nav pending-sync badge (caps at 99+). */
export function formatShellNavPendingSyncBadgeCount(total: number): string {
  if (total <= 0) return '';
  return total > 99 ? '99+' : String(total);
}

/** Spanish aria-label fragment when pending uploads exist. */
export function shellNavSyncPendingAriaLabel(count: number): string {
  if (count <= 0) return 'Sincronización';
  const n = count > 99 ? 'más de 99' : String(count);
  const reg = count === 1 ? 'registro pendiente' : 'registros pendientes';
  return `Sincronización, ${n} ${reg} de envío`;
}

/** Colored badge for pending upload count (hidden when zero). */
export function shellSyncPendingBadgeTemplate(
  pendingSyncCount: number,
  className = 'shell-pending-sync-badge',
): TemplateResult | typeof nothing {
  if (pendingSyncCount <= 0) return nothing;
  return html`<span class=${className} aria-hidden="true"
    >${formatShellNavPendingSyncBadgeCount(pendingSyncCount)}</span
  >`;
}

/** Accessible name for a shell nav/dashboard item. */
export function shellNavItemAccessibleLabel(label: string, path: string, pendingSyncCount: number): string {
  if (shellNavPathname(path) === SHELL_SYNC_NAV_PATH) return shellNavSyncPendingAriaLabel(pendingSyncCount);
  return label;
}
